import { FC, useState } from 'react';
import useColors from '../../../../../hooks/useColors';

interface DuplicateFieldsButtonProps {
  displayLabel: string;
  onClick: () => void;
  value: string;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset' | undefined;
}

const DuplicateFieldsButton: FC<DuplicateFieldsButtonProps> = (props) => {
  const { displayLabel, onClick, value, disabled, type } = props;
  const { primaryColor, secondaryColor } = useColors();
  const [isHover, setIsHover] = useState(false);

  const handleMouseEnter = () => {
    setIsHover(true);
  };
  const handleMouseLeave = () => {
    setIsHover(false);
  };

  return (
    <button
      type={type ? type : 'button'}
      onClick={onClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      value={value}
      disabled={disabled}
      className="
        border-2 px-4 py-1 rounded-full font-semibold font-roboto transition-all duration-200
        disabled:shadow-none shadow-sm text-white disabled:text-[#808080]
      "
      style={{
        color: disabled ? '#808080' : isHover ? secondaryColor : primaryColor,
        fontSize: '15px',
        borderColor: disabled
          ? '#808080'
          : isHover
            ? secondaryColor
            : primaryColor,
      }}
    >
      {displayLabel}
    </button>
  );
};

export default DuplicateFieldsButton;
